<template>
  <component
    :is="tag"
    v-on="$listeners"
  >
    <b-avatar
      v-if="noAvatar"
      size="42"
      :src="session.avatar"
      :badge="isChatContact"
      class="badge-minimal"
      :badge-variant="resolveAvatarBadgeVariant(session.status)"
      variant="transparent"
    />
    <div class="chat-info flex-grow-1">
      <div class="d-flex justify-content-between align-items-center mb-0">
        <h5 class="mb-0 text-capitalize" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
          {{ session.clientName }}
        </h5>
        <div class="text-right">
          {{ lastMessageTime }}
          <p class="m-0" v-if="!isChatContact && unseenMsgs && unseenMsgs > 0">
            <b-badge class="" pill variant="danger">{{unseenMsgs}}</b-badge>
          </p>
        </div>
      </div>
      <p class="card-text text-truncate">
        {{ !isChatContact ? lastMessage : session.about }}
      </p>
    </div>
    <div
      v-if="isChatContact"
      class="chat-meta text-nowrap"
    >
      <small class="float-right mb-25 chat-time">{{ formatDateToMonthShort(session.lastMessage.timestamp, { hour: 'numeric', minute: 'numeric' }) }}</small>
      <b-badge
        v-if="session.unseenMsgs"
        pill
        variant="primary"
        class="float-right"
      >
        {{ session.unseenMsgs }}
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue'
import { formatDateToMonthShort } from '@core/utils/filter'
import useChat from './useChat'
import { mapGetters } from 'vuex'

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    session: {
      type: Object,
      required: true,
    },
    isChatContact: {
      type: Boolean,
      default: false,
    },
    noAvatar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('chat', ['unseenMsgsBySessionId']),
    lastMessage(){
      return this.session?.lastMessage?.content || ''
    },
    lastMessageTime(){
      let lastMessage =  this.session?.lastMessage;
      if(!lastMessage) return ''
      let lastMessageTimeMoment = this.$moment.serverDateTime(lastMessage.timestamp);
      if(this.$moment().diff(lastMessageTimeMoment, 'days') === 0){
        return lastMessageTimeMoment.format(this.$t('timeFormat.time.format'))
      }
      return lastMessageTimeMoment.format(this.$t('timeFormat.dateTime.format'))
    },
    unseenMsgs(){
      return this.session.unseenMsgs
    },
  },
  setup() {
    const { resolveAvatarBadgeVariant } = useChat()
    return { formatDateToMonthShort, resolveAvatarBadgeVariant }
  },
}
</script>

<style>

</style>
